import { render } from "./RolesSettingsSection.vue?vue&type=template&id=46a157b0"
import script from "./RolesSettingsSection.vue?vue&type=script&lang=js"
export * from "./RolesSettingsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__